export default __webpack_public_path__ + "static/media/silvotel.e4d0f022.png";